import React from "react";
import UploadIcon from "../../../../Assets/images/uploadIcon.svg";

const CustomUpload = (props) => {
    const {fieldName, mandatory} = props;
    return (
	    <div className="flex justify-content-start align-items-center ml10 mr10 mt10 clickable">
            <span className={`fontsize16 bold ${mandatory? `mandatory` : undefined}`}>{fieldName}</span>
            <img src={UploadIcon} className="ml10 mr10" alt="upload attachment" />
	    </div>
    );
};



export default CustomUpload;
